import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.campaigns.promo.edit', []).controller('PromoEditCtrl', PromoEditCtrl)

/** @ngInject */
function PromoEditCtrl(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $timeout,
  CouponsService,
  PromoService,
) {
  var vm = this
  vm.model = {}
  vm.id = parseInt($stateParams.id)
  vm.parentId = parseInt($stateParams.parentId)
  vm.isOpen = false
  vm.coupons = []

  CouponsService.listPublished(0, 1000).then(function (result) {
    vm.coupons = result.results
  })

  vm.promoTypes = [
    {
      id: 0,
      name: 'Standard',
    },
    {
      id: 1,
      name: 'Sign Up',
    },
  ]

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  if (vm.id !== 0) {
    PromoService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      if (vm.model['ts-x'] !== undefined && vm.model['ts-x'] !== 0) {
        vm.model['ts-x'] = vm.model['ts-x']
          .toString()
          .substring(0, vm.model['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x']))
        vm.data1 = angular.copy(vm.model['ts-x'])
      }
    })
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    if (model.t === undefined || model.txt === undefined) {
      swal('Required title, description', '', 'error')
      return
    }

    if (model.m) {
      if (model.code === undefined || model.code === null || model.code === '') {
        model.m = false
      }
      if (model.c) {
        swal(
          "'Many' can not be checked when creating coin promo's! De-select 'Many' to continue.",
          '',
          'warning',
        )
        return
      }
    } else {
      model.code = null
      model.ct = null
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x'] = null
    }

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      PromoService.update(vm.parentId, model.id, model).then(function () {
        $timeout(function () {
          $state.go('admin.promo_campaigns.promo', { parentId: vm.parentId })
        }, 500)
      })
    } else {
      PromoService.save(vm.parentId, model).then(function () {
        $timeout(function () {
          $state.go('admin.promo_campaigns.promo', { parentId: vm.parentId })
        }, 500)
      })
    }
  }

  vm.cancel = function () {
    $state.go('admin.promo_campaigns.promo', { parentId: vm.parentId })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
  })

  vm.newCoupon = function (from) {
    vm.from = from
    $rootScope.$broadcast('modalNewCoupon', 0)
    $timeout(function () {
      $('#modalNewCoupon').modal('show')
    }, 250)
  }

  $('#modalNewCoupon').on('hidden.bs.modal', function () {
    if (localStorage.getItem('promo_coupon_id')) {
      CouponsService.listPublished(0, 1000).then(function (result) {
        vm.coupons = result.results
        vm.couponId = parseInt(localStorage.getItem('promo_coupon_id'))

        vm.model[vm.from] = vm.couponId
      })
    }
  })
}
